//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminObligationController_create,
  Response$AdminObligationController_create$Status$201,
  ResponseContentType$AdminObligationController_create,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminObligationController_create = () =>
  useApiClientMutation<
    Params$AdminObligationController_create,
    Response$AdminObligationController_create$Status$201[ResponseContentType$AdminObligationController_create]
  >({ method: 'AdminObligationController_create' });
